// Angular
import { BrowserModule }          from '@angular/platform-browser';
import { NgModule }               from '@angular/core';
import { FormsModule}             from '@angular/forms';
import { HttpClientModule }       from '@angular/common/http';


// Submodules
import { AppRoutingModule }       from './app-routing.module';
import { Mediator }               from './mediator';
import { SharedModule }           from 'app/shared/shared.module';
import { CoreModule }             from 'app/core/core.module';
import { AppComponent }           from 'app/app.component';
import { PageNotFoundComponent }  from 'app/not-found.component';


// Imports all other modules we want to plug in the application
// Provides services we want to expose globally inside the application and instantiate only once
// Declares the application’s root component
// Bootstraps the root component that Angular creates and inserts it into the index.html host web page
@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent    
  ],
  imports: [
    // Angular core
    BrowserModule,
    FormsModule,
    HttpClientModule,

    // Bootstrap
    /*AlertModule.forRoot(),
    AccordionModule.forRoot(),
    PopoverModule.forRoot(),
    BsDropdownModule.forRoot(),

    TreeviewModule.forRoot(),
    //AngularOpenlayersModule,
    NgxChartsModule, 
    */
    
    // App
    AppRoutingModule,
    CoreModule,
    SharedModule

    // Local
    
  ],
  providers: [Mediator],
  bootstrap: [AppComponent]
})
export class AppModule {   

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/app.module.ts